<script setup>
import { useRouter } from 'vue-router';
import { ROUTES } from '@/router/routeNames';

const router = useRouter();

const goBack = () => {
  router.back();
};

const goHome = () => {
  router.push({ name: ROUTES.HOME });
};
</script>

<template>
  <div class="bb-shell flex justify-center items-center px-5 min-h-screen">
    <div class="auth-rise w-full max-w-md text-center">
      <p class="text-sm font-semibold tracking-[0.2em] uppercase text-emerald-600">Lost the trail</p>
      <h1 class="mt-3 text-7xl font-black tracking-tight text-gray-900 sm:text-8xl dark:text-white">404</h1>
      <h2 class="mt-3 text-2xl font-bold text-gray-900 dark:text-white">This page isn’t on the route</h2>
      <p class="mt-3 text-base leading-relaxed text-gray-600 dark:text-gray-300">
        The link may be old, or the page may have moved. You can head back or return home.
      </p>
      <div class="flex flex-col gap-3 mt-8 sm:flex-row sm:justify-center">
        <button
          @click="goHome"
          class="px-5 py-3 text-sm font-semibold text-white bg-emerald-600 rounded-full shadow-lg transition duration-200 hover:bg-emerald-700 active:scale-[0.98]"
        >
          Go home
        </button>
        <button
          @click="goBack"
          class="px-5 py-3 text-sm font-semibold text-gray-800 bg-white rounded-full shadow-sm ring-1 ring-black/5 transition duration-200 hover:-translate-y-0.5 active:scale-[0.98] dark:bg-gray-800 dark:text-gray-100"
        >
          Go back
        </button>
      </div>
    </div>
  </div>
</template>
